// @flow

import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { TwitterPicker } from 'react-color';
import { log } from '../../utils/jsUtils';
import { useSelector, useDispatch } from 'react-redux';
import { selectI18n } from '../../reduxStore/modules/common/selectors';

import Popper from '@mui/material/Popper';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTheme } from '@mui/material/styles';
import TagReadonly from '../SharedComponents/TagReadonly';

import { createClasses } from '../../utils/stylesUtils';
import styles from './Styles/EditTagDialog.Style';
import type { Tag } from '../../services/SPBackend';

type Props = {
  setOpen: Function,
  open: boolean,
  actionConfirm: Function,
  tag: Tag
}

const EditTagDialog = (props: Props) => {
  const {
    setOpen,
    open,
    actionConfirm,
    tag
  } = props;
  
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [displayColorPicker, setDisplayColorPicker] = useState(false);
  const [editedTag, setEditedTag] = useState(null);
  const inputEl = useRef(null);

  const dispatch = useDispatch();
  const i18n = useSelector(selectI18n);

  const theme = useTheme();
  const classes = createClasses(styles, theme);

  useEffect(() => {
    log('[EditTagDialog] useEffect...');
    log('[EditTagDialog] tag prop: ', tag);
    if (tag !== null) {
      log('[EditTagDialog] useEffect tag: ', tag);
      log('[EditTagDialog] tag structure: ', {
        _id: tag._id,
        Name: tag.Name,
        Color: tag.Color,
        name: tag.name,
        color: tag.color
      });
      setEditedTag(tag);
    }
  }, [tag]);

  const handleColorPicked = (color: Object, event: Object) => {
    log('[handleColorPicked]... color: ', color);
    log('[handleColorPicked]... tag: ', tag);
    if (typeof tag != 'undefined' && tag !== null && editedTag !== null) {
      // toggle picker
      setEditedTag({
        ...editedTag,
        Color: color.hex
      });
      setDisplayColorPicker(false);
      setAnchorEl(null);
    }
  };

  const handleEditTagName = (e: Object) => {
    if (editedTag !== null) {
      setEditedTag({
        ...editedTag,
        Name: e.target.value
      });
    }
  };
  
  const handleColorPickerClick = (event: Object) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
    // inputEl.current.focus();
  };
  const openColorPicker = Boolean(anchorEl);
  const colorPickerId = openColorPicker ? 'simple-popper' : undefined;

  return (
    <div>
    {
      (editedTag !== null && typeof editedTag !== 'undefined')
      ? <Dialog
          aria-labelledby='form-add-property'
          disableEnforceFocus
          onClose={() => setOpen(false)}
          open={open}
        >
          <DialogTitle id='form-dialog-title'>
          {'Edit tag'}
          </DialogTitle>
          <DialogContent style={{ ...classes.grow, ...classes.flexContainer }}>
            <DialogContentText>
              {'You are editing this tag:'}<br />
            </DialogContentText>
            <div>
              {log('[EditTagDialog] Rendering TagReadonly with editedTag: ', editedTag)}
              <TagReadonly
                  tag={editedTag}
                  readonly
              />
            </div>
            <TextField
                style={classes.margin}
                id="input-with-icon-textfield"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <div style={classes.tagCtr}>
                        <div 
                          style={classes.colorPickerRainbow}
                          onClick={handleColorPickerClick} 
                        />
                      </div>
                    </InputAdornment>
                  ),
                }}
                onChange={handleEditTagName}
                value={editedTag.Name}
            />
            <Popper anchorEl={anchorEl}
              style={classes.popperCtr}
              id={colorPickerId}
              open={openColorPicker}
              placement='bottom'
            >
              <TwitterPicker onChangeComplete={handleColorPicked} />
            </Popper>
          </DialogContent>
          <DialogActions>
            <Button 
              color='primary'
              onClick={() => setOpen(false)}
              type='button'
            >
              {'Cancel'}
              </Button>
            <Button 
              color='primary'
              onClick={() => { 
                actionConfirm(editedTag); 
                setOpen(false); 
                }
              }
              variant='contained'
            >
              {'Save changes'}
              </Button>
          </DialogActions>
        </Dialog>
      : null
    }
    </div>
  );
};

export default EditTagDialog;